import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Divider } from 'antd'

export const Container = styled(Flex)`
  margin-bottom: 30px;
`
export const FlexWrap = styled(Flex)`
  gap: ${props => (props?.gap ? props.gap : '0')};
  padding: ${props => (props?.padding ? props.padding : '10px 25px')};
  border: ${props => (props?.border ? props.border : '0px')} solid
    ${COLORS.GREY_T_90};
  border-radius: 10px;
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px 0 25px;
  position: relative;
  background-color: ${COLORS.BLUE_T_97};
  margin-bottom: 40px;
`
export const TopHeader = styled(Flex)`
  gap: 20px;
`
export const HeaderFlex = styled(Flex)`
  position: relative;
  top: 30px;
`
export const CollegeName = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
`
export const GreySmall = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const GreyMedium = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  span {
    font-weight: ${FONT.FW_700};
  }
`
export const MainHeading = styled.h1`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT?.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_T_30};
`
export const Left = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
`
export const Right = styled(Flex)`
  background: ${COLORS.WHITE};
  width: ${props => (props.width ? props.width : '100%')};
  gap: 20px;
`
export const GreyText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: 0;
`
export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 5px;
`
export const StyledP = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${COLORS.F_SM};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_50_2)};
  margin-bottom: 0;
  ${props => props?.width && `width: ${props?.width}`}
`
export const CapsSmall = styled.p`
  font-weight: ${FONT.FW_500};
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${COLORS.GREY_T_50_2};
`
export const StyledDivider = styled(Divider)`
  margin: ${props => (props.margin ? props.margin : '15px 0')};
`
export const Links = styled.a`
  width: ${props => (props?.width ? props?.width : 'auto')};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  :hover {
    color: ${COLORS.GREY_T_30};
  }
`
